import SyncRecipes from './admin/sync-recipes';

window.addEventListener('load', () => {
  const urlParams = new URLSearchParams(location.search);

  if(urlParams.get('page') === 'general') {
    new SyncRecipes;
  }
})
